module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('el-radio-group', _vm._b({
    attrs: {
      "disabled": _vm.disabled
    },
    on: {
      "change": _vm.handleChange
    },
    model: {
      value: (_vm.selectValue),
      callback: function($$v) {
        _vm.selectValue = $$v
      },
      expression: "selectValue"
    }
  }, 'el-radio-group', _vm.$attrs, false), [_vm._t("default")], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-38e2b4c3"}!./~/vue-loader/lib/selector.js?type=template&index=0!./~/vue-xpc/src/components/radio/rtRadioGroup.vue
// module id = 1490
// module chunks = 124